import(/* webpackMode: "eager" */ "/home/ubuntu/download/6930754c5a24100014d6bde6/finvion_landing_page/src/app/finvion-story-de/page.tsx");
